import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getVideos,
  getVideo,
  requestVideoUploadUrl,
  uploadToS3,
  createVideo,
  updateVideo,
  requestVideoReplaceUrl,
  completeVideoReplacement,
  requestVideoReplaceUrlFr,
  completeVideoReplacementFr,
  getVideoPlayUrl,
  deleteVideo,
} from "../../services/videoApi";

const FETCH_ADMIN_VIDEOS = "fetchAdminVideosAction";
const FETCH_ADMIN_VIDEO = "fetchAdminVideoAction";
const REQUEST_VIDEO_UPLOAD_URL = "requestVideoUploadUrlAction";
const UPLOAD_VIDEO_TO_S3 = "uploadVideoToS3Action";
const CREATE_ADMIN_VIDEO = "createAdminVideoAction";
const UPDATE_ADMIN_VIDEO = "updateAdminVideoAction";
const REQUEST_VIDEO_REPLACE_URL = "requestVideoReplaceUrlAction";
const COMPLETE_VIDEO_REPLACE = "completeVideoReplacementAction";
const REQUEST_VIDEO_REPLACE_URL_FR = "requestVideoReplaceUrlFrAction";
const COMPLETE_VIDEO_REPLACE_FR = "completeVideoReplacementFrAction";
const FETCH_VIDEO_PLAY_URL = "fetchVideoPlayUrlAction";
const DELETE_ADMIN_VIDEO = "deleteAdminVideoAction";

export const fetchAdminVideosAction = createAsyncThunk(
  FETCH_ADMIN_VIDEOS,
  async (params, { rejectWithValue }) => {
    try {
      const result = await getVideos(params);
      return result;
    } catch (error) {
      return rejectWithValue({ message: error?.message });
    }
  }
);

export const fetchAdminVideoAction = createAsyncThunk(
  FETCH_ADMIN_VIDEO,
  async (id, { rejectWithValue }) => {
    try {
      const result = await getVideo(id);
      return result;
    } catch (error) {
      return rejectWithValue({ message: error?.message });
    }
  }
);

export const requestVideoUploadUrlAction = createAsyncThunk(
  REQUEST_VIDEO_UPLOAD_URL,
  async (body, { rejectWithValue }) => {
    try {
      const result = await requestVideoUploadUrl(body);
      return result;
    } catch (error) {
      return rejectWithValue({ message: error?.message });
    }
  }
);

export const uploadVideoToS3Action = createAsyncThunk(
  UPLOAD_VIDEO_TO_S3,
  async ({ uploadUrl, file, onProgress }, { rejectWithValue }) => {
    try {
      const result = await uploadToS3(uploadUrl, file, onProgress);
      if (!result?.success) {
        return rejectWithValue(result);
      }
      return result;
    } catch (error) {
      return rejectWithValue({ message: error?.message });
    }
  }
);

export const createAdminVideoAction = createAsyncThunk(
  CREATE_ADMIN_VIDEO,
  async (body, { rejectWithValue }) => {
    try {
      const result = await createVideo(body);
      return result;
    } catch (error) {
      return rejectWithValue({ message: error?.message });
    }
  }
);

export const updateAdminVideoAction = createAsyncThunk(
  UPDATE_ADMIN_VIDEO,
  async ({ id, body }, { rejectWithValue }) => {
    try {
      const result = await updateVideo(id, body);
      return result;
    } catch (error) {
      return rejectWithValue({ message: error?.message });
    }
  }
);

export const requestVideoReplaceUrlAction = createAsyncThunk(
  REQUEST_VIDEO_REPLACE_URL,
  async ({ id, body }, { rejectWithValue }) => {
    try {
      const result = await requestVideoReplaceUrl(id, body);
      return result;
    } catch (error) {
      return rejectWithValue({ message: error?.message });
    }
  }
);

export const completeVideoReplacementAction = createAsyncThunk(
  COMPLETE_VIDEO_REPLACE,
  async ({ id, body }, { rejectWithValue }) => {
    try {
      const result = await completeVideoReplacement(id, body);
      return result;
    } catch (error) {
      return rejectWithValue({ message: error?.message });
    }
  }
);

export const requestVideoReplaceUrlFrAction = createAsyncThunk(
  REQUEST_VIDEO_REPLACE_URL_FR,
  async ({ id, body }, { rejectWithValue }) => {
    try {
      const result = await requestVideoReplaceUrlFr(id, body);
      return result;
    } catch (error) {
      return rejectWithValue({ message: error?.message });
    }
  }
);

export const completeVideoReplacementFrAction = createAsyncThunk(
  COMPLETE_VIDEO_REPLACE_FR,
  async ({ id, body }, { rejectWithValue }) => {
    try {
      const result = await completeVideoReplacementFr(id, body);
      return result;
    } catch (error) {
      return rejectWithValue({ message: error?.message });
    }
  }
);

export const fetchVideoPlayUrlAction = createAsyncThunk(
  FETCH_VIDEO_PLAY_URL,
  async ({ id, videoLang } = {}, { rejectWithValue }) => {
    try {
      const result = await getVideoPlayUrl(id, videoLang);
      return result;
    } catch (error) {
      return rejectWithValue({ message: error?.message });
    }
  }
);

export const deleteAdminVideoAction = createAsyncThunk(
  DELETE_ADMIN_VIDEO,
  async (id, { rejectWithValue }) => {
    try {
      const result = await deleteVideo(id);
      return result;
    } catch (error) {
      return rejectWithValue({ message: error?.message });
    }
  }
);
